module.exports = __webpack_public_path__ + "static/media/navigation_separator.d9117d83.svg";